import { CrudTable, StatusBadge } from "@/components/shared";

const TYPES = ["Swelling", "Infection", "Delayed Healing", "Scarring", "Allergic Reaction", "Asymmetry", "Other"];
const YesNo = ({ v }) => <span className={v ? "text-[#34d399]" : "text-slate-500"}>{v ? "Yes" : "No"}</span>;

export default function Complications() {
  const columns = [
    { key: "date_reported", label: "Reported", render: (r) => r.date_reported?.slice(0, 10) },
    { key: "patient_name", label: "Patient" },
    { key: "branch", label: "Branch" },
    { key: "procedure", label: "Procedure" },
    { key: "complication_type", label: "Complication" },
    { key: "severity", label: "Severity", render: (r) => <StatusBadge value={r.severity} /> },
    { key: "managed_by", label: "Managed By" },
    { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "followup_done", label: "Follow-up", render: (r) => <YesNo v={r.followup_done} /> },
  ];
  const fields = [
    { key: "patient_id", label: "Patient (linked)", type: "patient", full: true },
    { key: "patient_name", label: "Patient Name (or type manually)", type: "text" },
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "procedure", label: "Procedure", type: "text" },
    { key: "complication_type", label: "Complication Type", type: "select", options: TYPES },
    { key: "severity", label: "Severity", type: "select", options: ["Low", "Medium", "High", "Critical"] },
    { key: "status", label: "Status", type: "select", options: ["Open", "Under Treatment", "Resolved"] },
    { key: "managed_by", label: "Managed By", type: "text" },
    { key: "followup_done", label: "Follow-up Done", type: "switch" },
    { key: "action_taken", label: "Action Taken", type: "textarea", full: true },
    { key: "notes", label: "Notes", type: "textarea", full: true },
  ];
  return (
    <CrudTable
      testid="complications" endpoint="complications"
      title="Complications Handling"
      subtitle="Log post-procedure complications, how they were managed, and confirm closure — patient safety and trust."
      columns={columns} fields={fields}
      defaults={{ severity: "Low", status: "Open", followup_done: false }}
    />
  );
}
